module.exports = __webpack_public_path__ + "static/media/26UNRWA2.88304dd7.jpg";